/* eslint-env browser */
import('./script.js')
